import { api } from "@breakout/backend/convex/_generated/api"
import type { Maybe } from "@breakout/shared/types/market"
import { usePaginatedQuery } from "convex/react"
import type { Address } from "viem"

type SortBy = "time" | "amount"
type SortDirection = "asc" | "desc"

interface UserActivityArgs {
	userAddress: Address
	sortBy?: SortBy
	sortDirection?: SortDirection
}

export function useUserActivityPaginated(args: Maybe<UserActivityArgs>) {
	const { results, status, loadMore, isLoading } = usePaginatedQuery(
		api.indexer.public.getUserActivity,
		args
			? {
					userAddress: args.userAddress,
					sortBy: args.sortBy ?? "time",
					sortDirection: args.sortDirection ?? "desc",
				}
			: "skip",
		{ initialNumItems: 20 },
	)

	return {
		results,
		status,
		loadMore,
		isLoading,
		hasMore: status === "CanLoadMore",
	}
}
